import { render } from "./InActivePhysicians.vue?vue&type=template&id=175caba0"
import script from "./InActivePhysicians.vue?vue&type=script&lang=js"
export * from "./InActivePhysicians.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/physicians/InActivePhysicians.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "175caba0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('175caba0', __exports__)) {
    console.log('reload')
    api.reload('175caba0', __exports__)
  }
  
  module.hot.accept("./InActivePhysicians.vue?vue&type=template&id=175caba0", () => {
    console.log('re-render')
    api.rerender('175caba0', render)
  })

}


export default __exports__